// ═══════════════════════════════════════════════════════════
// Session persistence — sessionStorage
// ═══════════════════════════════════════════════════════════

import type { AuthTokens, V2User } from '../api/types';

const SESSION_KEY = 'ogemc_session';

export interface StoredSession {
  tokens: AuthTokens;
  user: V2User;
}

export function saveSession(session: StoredSession): void {
  try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(session)); } catch {}
}

export function loadSession(): StoredSession | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const session: StoredSession = JSON.parse(raw);
    if (session.tokens.expiresAt < Date.now()) { clearSession(); return null; }
    return session;
  } catch { return null; }
}

export function clearSession(): void {
  try { sessionStorage.removeItem(SESSION_KEY); } catch {}
}
